// import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { SearchFilterOptionType } from "../data/types";
import HomePage from '../pages/shared/Desktop/HomePage'
import HomePageMobile from '../pages/shared/Mobile/HomePage'
import FoodEntrepreneurs from '../pages/shared/Desktop/FoodEntrepreneurs'
import FoodEntrepreneursMobile from '../pages/shared/Mobile/FoodEntrepreneurs'
import Privacy from '../pages/shared/Privacy'
import Terms from '../pages/shared/Terms'
import Disclaimer from '../pages/shared/Disclaimer'
import Eula from '../pages/shared/Eula'
import ResourceProviders from '../pages/shared/Desktop/ResourceProviders'
import ResourceProvidersMobile from '../pages/shared/Mobile/ResourceProviders'
import PawditRoute from '../pages/pawdit/PawditRoute'
import ComplianceRoute from '../pages/compliance/ComplianceRoute'

type AuthViewProps = {
  searchFilterOptions: SearchFilterOptionType
}

const AuthView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/food-entrepreneurs" element={<FoodEntrepreneurs />} />
        <Route path="/resource-providers" element={<ResourceProviders />} />
        <Route path="/pawdit" element={<PawditRoute />} />
        <Route path="/compliance/*" element={<ComplianceRoute />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="*" element={<FoodEntrepreneurs />} />
    </Routes>
  )
}


export const MobileAuthView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/" element={<HomePageMobile />} />
        <Route path="/food-entrepreneurs" element={<FoodEntrepreneursMobile />} />
        <Route path="/resource-providers" element={<ResourceProvidersMobile />} />
        <Route path="/pawdit" element={<PawditRoute />} />
        <Route path="/compliance/*" element={<ComplianceRoute />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="*" element={<FoodEntrepreneursMobile />} />
    </Routes>
  )
}


export const NoAuthEmailUsernameView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/food-entrepreneurs" element={<FoodEntrepreneurs />} />
        <Route path="/resource-providers" element={<ResourceProviders />} />
        <Route path="/pawdit" element={<PawditRoute />} />
        <Route path="/compliance/*" element={<ComplianceRoute />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="*" element={<FoodEntrepreneurs />} />
    </Routes>
  )
}


export const MobileNoAuthEmailUsernameView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/" element={<HomePageMobile />} />
        <Route path="/food-entrepreneurs" element={<FoodEntrepreneursMobile />} />
        <Route path="/resource-providers" element={<ResourceProvidersMobile />} />
        <Route path="/pawdit" element={<PawditRoute />} />
        <Route path="/compliance/*" element={<ComplianceRoute />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="*" element={<FoodEntrepreneursMobile />} />
    </Routes>
  )
}


export default AuthView;
